import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  scorecard: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.scorecard`,
    defaultMessage: 'Scorecard',
  },
  description: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.description`,
    defaultMessage: 'Attach a scorecard to evaluate the applicant.',
  },
  addScorecard: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.addScorecard`,
    defaultMessage: 'Add Scorecard',
  },
  removeScorecard: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.removeScorecard`,
    defaultMessage: 'Remove scorecard',
  },
  removeScorecardConfirmation: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.removeScorecardConfirmation`,
    defaultMessage:
      'Are you sure you want to remove "{name}" from this stage? Evaluators will no longer be asked to score applicants here.',
  },
  unavailableScorecard: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.unavailableScorecard`,
    defaultMessage: 'Unavailable scorecard',
  },
});
